import React from "react";
import {
    BrowserRouter as Router,
    Switch,
    Route
} from "react-router-dom";

import { LoginScreen } from "../screens";


const routes = [
    {
        path: "/",
        component: LoginScreen
    },
    {
        path: '/register',
        component: LoginScreen
    }
]

const SessionRoutes = () => {
    return (

        <Switch>
            {
                routes.map((route, i) => (
                    <Route
                        exact
                        key={i}
                        path={route.path}
                        render={
                            props => (
                                <route.component {...props} routes={route.routes} />
                            )
                        }
                    />
                ))
            }
        </Switch>

    )
}

export default SessionRoutes
